import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'
import { Button } from 'antd'
import SparkleOverlay from './SparkleOverlay'

import './NewProviderDirectoryDialog.css'

const NewProviderDirectoryDialog = () => {
  const dispatch = useDispatch()
  const isNewProviderDirectoryDialogNeedToBeVisible = useSelector(
    state => state.app.isNewProviderDirectoryDialogNeedToBeVisible
  )

  const onCloseDialog = () => {
    dispatch(Actions.createAction(Actions.NEW_PROVIDER_DIRECTORY_DIALOG_CLOSED))
  }

  if (!isNewProviderDirectoryDialogNeedToBeVisible) {
    return null
  }

  return (
    <Dialog
      className='new-provider-directory-dialog'
      title={$t('searchProviders.newProviderDirectory.title')}
      isVisible={isNewProviderDirectoryDialogNeedToBeVisible}
      onCancel={onCloseDialog}
      footerActions={[
        <Button
          key='close'
          className='new-provider-directory-dialog-submit-button'
          type='primary'
          onClick={onCloseDialog}
        >
          {$t('common.gotIt')}
        </Button>
      ]}
      modalRender={modal => (
        <>
          <SparkleOverlay />
          {modal}
        </>
      )}
    >
      <div className='new-provider-directory-dialog-content'>
        <div className='new-provider-directory-dialog-content-subtitle'>
          {$t('searchProviders.newProviderDirectory.subtitle')}
        </div>
        <div className='new-provider-directory-dialog-content-points'>
          <div className='new-provider-directory-dialog-content-point'>
            <div className='new-provider-directory-dialog-content-point-title'>
              {$t('searchProviders.newProviderDirectory.firstPointTitle')}
            </div>
            <div className='new-provider-directory-dialog-content-point-subtitle'>
              {$t('searchProviders.newProviderDirectory.firstPointSubtitle')}
            </div>
          </div>
          <div className='new-provider-directory-dialog-content-point'>
            <div className='new-provider-directory-dialog-content-point-title'>
              {$t('searchProviders.newProviderDirectory.secondPointTitle')}
            </div>
            <div className='new-provider-directory-dialog-content-point-subtitle'>
              {$t('searchProviders.newProviderDirectory.secondPointSubtitle')}
            </div>
          </div>
          <div className='new-provider-directory-dialog-content-point'>
            <div className='new-provider-directory-dialog-content-point-title'>
              {$t('searchProviders.newProviderDirectory.thirdPointTitle')}
            </div>
            <div className='new-provider-directory-dialog-content-point-subtitle'>
              {$t('searchProviders.newProviderDirectory.thirdPointSubtitle')}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default NewProviderDirectoryDialog
